exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#monitorables-page-container{width:100%;padding:20px;background-color:#fff}#monitorables-page-container .monitorables-page-content{margin-bottom:50px}#monitorables-page-container .monitorables-page-content .add-monitorable-btn{margin:15px;margin-top:0}#monitorables-page-container .monitorables-page-content .edit-cell button{width:80%;margin-left:10%}#monitorables-page-container .monitorables-page-content .delete-cell{width:100%;font-size:20px;color:red;text-align:center}#monitorables-page-container .monitorables-page-content .row{padding-top:5px;padding-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./styles/settings/monitoring/monitorables.scss
// module id = 2172
// module chunks = 43